module.exports = __webpack_public_path__ + "img/6.62dc3841.png";